"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var styled_system_1 = require("styled-system");

var GRID_MAX_WIDTH = '1188px';
exports.GRID_MAX_WIDTH = GRID_MAX_WIDTH;
var GRID_GUTTER_SCALE = ['layout.xxxxs', 'layout.xxxs', 'layout.xxs', 'layout.xs', 'layout.sm'];
exports.GRID_GUTTER_SCALE = GRID_GUTTER_SCALE;
exports.Grid = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: ", ";\n  ", ";\n"], ["\n  max-width: ", ";\n  ", ";\n"])), GRID_MAX_WIDTH, styled_system_1.space);
exports.Grid.defaultProps = {
  mx: ['layout.xxs', 'layout.xs', 'layout.sm', 'layout.lg', 'auto']
};

var getGridRowMargin = function getGridRowMargin(space, scale) {
  return "calc(" + styled_system_1.get(scale, space, '0') + " / 2 * -1)";
};

var gridRowMarginLeft = styled_system_1.style({
  cssProperty: 'margin-left',
  prop: 'gridMargin',
  key: 'space',
  transformValue: getGridRowMargin
});
var gridRowMarginRight = styled_system_1.style({
  cssProperty: 'margin-right',
  prop: 'gridMargin',
  key: 'space',
  transformValue: getGridRowMargin
});
var gridRowAlignItems = styled_system_1.style({
  cssProperty: 'justify-content',
  prop: 'alignItems',
  key: 'grid.alignments'
});
var GridRow = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex: 0 1 auto;\n  flex-direction: row;\n  flex-wrap: wrap;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), styled_system_1.space, gridRowMarginLeft, gridRowMarginRight, gridRowAlignItems);
GridRow.defaultProps = {
  gridMargin: GRID_GUTTER_SCALE
};

var getPercentageWidthByColumns = function getPercentageWidthByColumns(columns) {
  return columns / 12 * 100 + "%";
};

var getPaddingForGutter = function getPaddingForGutter(space, scale) {
  return "0 calc(" + styled_system_1.get(scale, space, '0') + " / 2)";
};

var gridItemFlexBasis = styled_system_1.style({
  cssProperty: 'flex-basis',
  prop: 'columns',
  transformValue: getPercentageWidthByColumns
});
var gridItemMaxWidth = styled_system_1.style({
  cssProperty: 'max-width',
  prop: 'columns',
  transformValue: getPercentageWidthByColumns
});
var gridItemPadding = styled_system_1.style({
  prop: 'gutter',
  cssProperty: 'padding',
  key: 'space',
  // @ts-ignore
  transformValue: getPaddingForGutter
});
var gridItemOffset = styled_system_1.style({
  prop: 'offset',
  cssProperty: 'margin-left',
  transformValue: getPercentageWidthByColumns
});
var GridItem = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  flex-basis: 0;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  flex-grow: 1;\n  flex-basis: 0;\n  box-sizing: border-box;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), styled_system_1.space, gridItemPadding, gridItemOffset, gridItemFlexBasis, gridItemMaxWidth);
GridItem.defaultProps = {
  gutter: ['layout.xxxxs', 'layout.xxxs', 'layout.xxs', 'layout.xs', 'layout.sm']
};
exports.Grid.Row = GridRow;
exports.Grid.Item = GridItem;
var templateObject_1, templateObject_2, templateObject_3;